// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import MenuItem from '..'

import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'

class StrongAuthentication extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
        buttonText={<><ContactSupportOutlinedIcon />Contact our sales team</>}
        href={'https://www.verimatrix.com/online-contact-form'}
      >
        <div className='strong-authentication product-details'>
          <div className='row title'>
            <p>Verimatrix is the leading provider of software security solutions. Its Strong Authentication (SA) solution complements existing systems with password-less 2FA/MFA.</p>
          </div>
          <div className='row text'>
            <ul>
              <li className='lh'>{'Strong Authentication key features include:'}</li>
              <li>{'Works with existing systems (no costly replacement needed)'}</li>
              <li>{'Seamlessly integrates biometric and PIN-based authentication into existing mobile apps on iOS and Android'}</li>
              <li>{'Does not store any user information'}</li>
              <li>{'Supports multiple authentication and authorization methods under the same integration API'}</li>
              <li>{'Allows service providers to choose their own deployment strategies and use cases'}</li>
            </ul>
          </div>
        </div>
      </MenuItem>
    )
  }
}

export default (StrongAuthentication)
